import Location from '../../../hooks/Location'
import useAdressMaterials from '../../../hooks/useAdressMaterials'
import formatCo2 from '../../../helpers/materialsHelpers/formatCo2'
import ImpactUnknownNote from './ImpactUnknownNote'

/**
 * Bespaarde CO2 for one household, from the materials registered on it.
 *
 * Reads the shared useAdressMaterials hook rather than computing anything of
 * its own, so this card, the savings card and the Materialen tab can never
 * disagree about the same household.
 */
const Co2SavedCard = () => {
    const adressId = Location()[3]
    const { impact, loading, impactError } = useAdressMaterials(adressId || '')

    // A dash while loading, and a dash when nothing is calculable — the one
    // thing this must never show is 0,0 kg for a household we simply could not
    // measure.
    const total = loading ? '—' : formatCo2(impact.co2Kg)

    return (
        <div className='new-dashboard-card'>
            <div className='new-dashboard-card-content'>
                <h3 className='new-dashboard-card-title'>Bespaarde CO2</h3>
                <p className='adress-impact-headline'>{total}</p>
                <p className='adress-impact-sub'>per jaar, op basis van de meetstandaard</p>

                {!loading && impact.perCode.length > 0 && (
                    <ul className='adress-dashboard-data-list'>
                        {impact.perCode.map((c) => (
                            <li key={c.code} className='adress-dashboard-data-row'>
                                <span className='adress-dashboard-data-label'>{c.name}</span>
                                <span className='adress-dashboard-data-value'>{formatCo2(c.co2Kg)}</span>
                            </li>
                        ))}
                    </ul>
                )}

                {!loading && (
                    <ImpactUnknownNote unknownCount={impact.unknownCount} error={impactError} />
                )}
            </div>
        </div>
    )
}

export default Co2SavedCard
